import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { filter, take, takeUntil, tap } from 'rxjs/operators';
import { StudentRoleSettings, UserLevelEnum } from 'src/app/auth/models/UserData';
import { AuthService } from 'src/app/auth/services/auth.service';
import { UserService } from 'src/app/auth/services/user.service';
import { HomepageSetting } from 'src/app/modules/framework/home-pages/employee-home-page/models/HomepageSettings';
import { HomepageService } from 'src/app/modules/framework/home-pages/employee-home-page/services/homepage.service';
import { ManagerScope } from 'src/app/modules/framework/home-pages/manager-hr-dashboard/models/TeamMemberRequest';
import { Widget } from 'src/app/modules/framework/home-pages/models/Widget';
import { Task, TaskCategory } from 'src/app/modules/framework/tasks/models/Task';
import { TaskOverview } from 'src/app/modules/framework/tasks/models/TaskOverview';
import { LocalHrTasksService } from 'src/app/modules/framework/tasks/services/localhr-tasks.service';
import { TaskLogicService } from 'src/app/modules/framework/tasks/services/task-logic.service';
import { TasksService } from 'src/app/modules/framework/tasks/services/tasks.service';
import { Student } from 'src/app/modules/lms/learningpaths/models/interfaces';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';
import { MenuItem } from 'src/app/shared/framework/navigation/models/MenuItem';
import { MenuItemFavourite } from 'src/app/shared/framework/navigation/models/MenuItemFavourite';
import { NavigationService } from 'src/app/shared/framework/navigation/services/navigation.service';
import { Company } from 'src/app/shared/personnel-files/models/Company';
import { ManagerType } from 'src/app/shared/personnel-files/models/ManagerType';
import { CompanyService } from 'src/app/shared/personnel-files/services/company.service';
import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';
import { BlackboardMessage } from 'src/app/modules/framework/blackboard/models/BlackboardMessage';


@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss'],
})
export class TopNavigationComponent implements OnInit, OnDestroy {
  @ViewChild('whoIsWhoSearchInput') whoIsWhoSearchInput: ElementRef<HTMLInputElement>;
  @ViewChild('employeeSearchInput') employeeSearchInput: ElementRef<HTMLInputElement>;
  @ViewChild('learningPlan') learningPlan: ElementRef<HTMLIFrameElement>;
  @ViewChild('overlaywrapper') overlaywrapper: ElementRef;
  @ViewChild('taskDropDown') taskDropDown: ElementRef<HTMLDivElement>;
  @ViewChild('searchInputCompany') searchInputCompany: ElementRef<HTMLInputElement>;
  @ViewChild('modalcontent') modalcontent: any;

  public eventsSubject: Subject<void> = new Subject<void>();

  public navigationStructure$: Observable<MenuItem>;
  public myProfileMenuItem$: Observable<MenuItem>;
  public employeeFischeMenuItem$: Observable<MenuItem>;
  public employeePicture$: Observable<IDataUrlParam>;
  public currentEmployee$: Observable<Student>;
  public taskOverview$: Observable<TaskOverview>;
  public messages$: Observable<BlackboardMessage[]>;
  public studentRoleSettings$: Observable<StudentRoleSettings>;
  public roles: StudentRoleSettings;


  public TaskCategories = TaskCategory;
  public Roles = UserLevelEnum;
  public tasks: Task[];
  public taskLength: number;
  public taskListOpen = false;
  public messages: BlackboardMessage[];
  public messageLength: number;
  public isOpen = false;
  public settings: HomepageSetting[] = [];
  public settingsWithMenuItem: HomepageSetting[];
  public settingsLoaded = false;
  public favourites: MenuItemFavourite[] = [];
  public showFavourites = false;
  public whoKind: number = 3;
  public roleLabel = '';
  public delegateView: boolean;
  public home: MenuItem;
  public activeMenuItem: MenuItem;
  public serviceDeskUrl = '';
  public companies: Company[] = [];
  public isScreenSmall = false;
  public isScreenMedium = false;
  public isScreenLarge = false;

  public widgetTasks: Widget;
  public widgetRecruitment: Widget;
  public widgetGoals: Widget;
  public widgetDevelopment: Widget;
  public widgetCertificates: Widget;
  public widgetSkills: Widget;
  public widgetConversations: Widget;
  public widgetBlackboard: Widget;

  public sortFavoriteMode = false;

  private _subscriptions: Subscription[] = [];
  private allTasks: Task[];
  private isManager = false;
  private isLhr = false;
  private readonly small = '(max-width: 600px)';
  private readonly medium = '(min-width: 601px) and (max-width: 1000px)';
  private readonly large = '(min-width: 1001px)';
  private destroy$ = new Subject<void>();

  breakpointObserver = inject(BreakpointObserver)

  constructor(
    private _employeeService: EmployeeService,
    private _companyService: CompanyService,
    private _navigationService: NavigationService,
    private _authService: AuthService,
    private tasksService: TasksService,
    private taskLogicService: TaskLogicService,
    private _localHrTasksService: LocalHrTasksService,
    private _homepageService: HomepageService,
    private _router: Router,
    private _userService: UserService,
    private modalService: NgbModal
  ) {
    this.breakpointObserver.observe
  }

  ngOnInit() {
    this.studentRoleSettings$ = this._authService.getUserRoles();
    this.employeePicture$ = this._employeeService.getEmployeePicture();
    this.currentEmployee$ = this._employeeService.getCurrentEmployee();

    this.breakpointObserver
      .observe([this.small, this.medium, this.large])
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.isScreenSmall = !!state.breakpoints[this.small];
        this.isScreenMedium = !!state.breakpoints[this.medium];
        this.isScreenLarge = !!state.breakpoints[this.large];
      });

    this._subscriptions.push(
      this._homepageService
        .getSettings(false)
        .subscribe((settings: HomepageSetting[]) => {
          if (localStorage.getItem('delegate_view') === '1') {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 333).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 333 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('manager_view') === '1') {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 33).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 33 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('trainer_view') === '1') {
            this.whoKind = 6;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 6).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 6 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('localhr_view') === '1') {
            this.whoKind = 2;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 2).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 2 && e.name == 'show_favourites')[0]?.value;
            this.isLhr = true;
          } else if (localStorage.getItem('corporatehr_view') === '1') {
            this.whoKind = 1;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 1).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 1 && e.name == 'show_favourites')[0]?.value;
          } else {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 3).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 3 && e.name == 'show_favourites')[0]?.value;
          }


          if (this.whoKind < 3) {
            this._subscriptions.push(
              this._employeeService.getUrlServicedesk().subscribe((url: string) => {
                this.serviceDeskUrl = url;
              })
            );
          }

          this.settings = settings;

          this.navigationStructure$ = this._navigationService.fetchMenu().pipe(
            tap((home: MenuItem) => {

              this.home = new MenuItem(home);
              this.setupNavigationEventListener();

              let menuFound = this.findMenuItemRecursive(home, [205, 258, 893, 204, 538])
              if (menuFound != null) {
                this.myProfileMenuItem$ = of(menuFound);
              }

              menuFound = this.findMenuItemRecursive(home, [417])
              if (menuFound != null) {
                this.employeeFischeMenuItem$ = of(menuFound);
              }

              let flatten = (children: MenuItem[], extractChildren) => Array.prototype.concat.apply(
                children,
                children.map(x => flatten(extractChildren(x) || [], extractChildren))
              );

              let extractChildren = (x: MenuItem) => x.subPages;

              let flatMenu = flatten(extractChildren(home), extractChildren).map((x: MenuItem) => delete x.subPages && x);


              this._subscriptions.push(
                this._homepageService.getWidgets().subscribe(e => {

                  this.widgetTasks = e.find(w => w.angularComponent == 'HOME_TASKS') || new Widget();
                  this.widgetRecruitment = e.find(w => w.angularComponent == 'HOME_RECRUITMENT') || new Widget();
                  this.widgetGoals = e.find(w => w.angularComponent == 'HOME_GOALS') || new Widget();
                  this.widgetDevelopment = e.find(w => w.angularComponent == 'HOME_DEVELOPMENT') || new Widget();
                  this.widgetCertificates = e.find(w => w.angularComponent == 'HOME_COMPLIANCE') || new Widget();
                  this.widgetSkills = e.find(w => w.angularComponent == 'HOME_MY_SKILLS') || new Widget();
                  this.widgetConversations = e.find(w => w.angularComponent == 'HOME_CONVERSATIONS') || new Widget();
                  this.widgetBlackboard = e.find(w => w.angularComponent == 'HOME_NOTIFICATIONS') || new Widget();

                  for (const menu of flatMenu) {
                    menu.cssIcon = menu.cssClass;

                    if (menu.cssIcon == 'fa-envelope') {
                      menu.customIcon = this.widgetTasks.customIcon;
                      menu.customCssIcon = this.widgetTasks.customCssIcon;
                      menu.cssIcon = this.widgetTasks.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-briefcase') {
                      menu.customIcon = this.widgetRecruitment.customIcon;
                      menu.customCssIcon = this.widgetRecruitment.customCssIcon;
                      menu.cssIcon = this.widgetRecruitment.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-bullseye') {
                      menu.customIcon = this.widgetGoals.customIcon;
                      menu.customCssIcon = this.widgetGoals.customCssIcon;
                      menu.cssIcon = this.widgetGoals.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-graduation-cap') {
                      menu.customIcon = this.widgetDevelopment.customIcon;
                      menu.customCssIcon = this.widgetDevelopment.customCssIcon;
                      menu.cssIcon = this.widgetDevelopment.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-certificate') {
                      menu.customIcon = this.widgetCertificates.customIcon;
                      menu.customCssIcon = this.widgetCertificates.customCssIcon;
                      menu.cssIcon = this.widgetCertificates.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-chart-line') {
                      menu.customIcon = this.widgetSkills.customIcon;
                      menu.customCssIcon = this.widgetSkills.customCssIcon;
                      menu.cssIcon = this.widgetSkills.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-comments') {
                      menu.customIcon = this.widgetConversations.customIcon;
                      menu.customCssIcon = this.widgetConversations.customCssIcon;
                      menu.cssIcon = this.widgetConversations.cssIcon;
                    }
                    if (menu.cssIcon == 'fa-bell') {
                      menu.customIcon = this.widgetBlackboard.customIcon;
                      menu.customCssIcon = this.widgetBlackboard.customCssIcon;
                      menu.cssIcon = this.widgetBlackboard.cssIcon;
                    }
                  }


                  for (const setting of this.settings) {
                    if (setting.menuItemId) {
                      if (flatMenu.filter((e: MenuItem) => e.id == setting.menuItemId && e.cssClass && e.cssClass != "").length) {
                        setting.menuItem = flatMenu.filter((e: MenuItem) => e.id == setting.menuItemId && e.cssClass && e.cssClass != "")[0];
                      }
                    }
                  }

                  let excludes = ['show_employees', 'show_print', 'show_search', 'show_searchresults', 'show_tickettool', 'show_who_is_who', 'show_tasks', 'show_timeline', 'show_notifications'];

                  this.settings = this.settings.filter(e => !e.menuItemId || e.menuItem || excludes.indexOf(e.name) > -1);

                  this._subscriptions.push(
                    this._navigationService.getFavourites().subscribe((favourites) => {
                      for (const favourite of favourites) {
                        favourite.menuItem = flatMenu.filter((e: MenuItem) => e.id == favourite.menuItemId)[0];
                      }

                      this.favourites = favourites.filter(e => e.menuItem).sort((a, b) => a.sortOrder - b.sortOrder);
                    })
                  );



                  this.settingsLoaded = true;
                })
              );
            })
          );
        })
    );

    this._subscriptions.push(
      this._userService.getUserRoles().pipe(take(1)).subscribe((roles) => {

        if (roles && roles.level) {
          let role = this.Roles[roles.level];
          if (roles.isManager && localStorage.getItem('manager_view') === '1') {
            role = 'manager';
          }
          this.roleLabel = role;
          this.eventsSubject.next();
        }

        var scope: ManagerScope = ManagerScope.Student;

        switch (roles.level) {
          case UserLevelEnum.Employee: scope = ManagerScope.Student; break;
          case UserLevelEnum.LocalHr: scope = ManagerScope.LHR; break;
          case UserLevelEnum.CorporateHr: scope = ManagerScope.HR; break;
          case UserLevelEnum.Delegate: scope = ManagerScope.Delegate; break;
        }

        if (localStorage.getItem('localhr_view') !== '1') {
          if (localStorage.getItem('delegate_view') === '1') {
            scope = ManagerScope.Delegate;
          } else if (localStorage.getItem('matrixmanager_view') === '1') {
            scope = ManagerScope.Matrix;
          } else if (localStorage.getItem('manager_view') === '1') {
            scope = ManagerScope.Direct;
          }

          this.taskOverview$ = this.tasksService.getTasks(localStorage.getItem('manager_view') === '1', scope, true).pipe(
            tap((taskOverview: TaskOverview) => {
              this.allTasks = this.taskLogicService.bundleTasks(
                taskOverview
              );
              this._subscriptions.push(
                this._authService.isManager().subscribe((man: ManagerType) => {
                  this.isManager = man.isManager || localStorage.getItem('matrixmanager_view') === '1';

                  if (this.delegateView) {
                    this.taskLength = this.allTasks.length;
                    this.tasks = this.allTasks.slice(0, 5);
                  }
                  else if (
                    this.isManager &&
                    (localStorage.getItem('manager_view') === '1' ||
                      localStorage.getItem('matrixmanager_view') === '1')
                  ) {
                    let tasks = this.allTasks.filter(
                      (task) =>
                        task.isTeamTask == true
                    );
                    this.taskLength = tasks.length;
                    this.tasks = tasks.slice(0, 5);
                  } else {
                    let tasks = this.allTasks.filter(
                      (task) =>
                        task.isTeamTask == false ||
                        (task.isTeamTask == true && !this.isManager && man.isOwnManager && task.category != TaskCategory.InformalConversationTeam)
                    );
                    this.taskLength = tasks.length;
                    this.tasks = tasks.slice(0, 5);
                  }
                })
              );
            })
          );
        } else {
          this.taskOverview$ = this._localHrTasksService.getTasks(true).pipe(
            tap((taskOverview: TaskOverview) => {
              this.allTasks = this.taskLogicService.bundleTasks(
                taskOverview
              );
              let tasks = this.allTasks;
              this.taskLength = tasks.length;
              this.tasks = tasks.slice(0, 5);
            })
          );

        }

        this.roles = roles;


      })
    );



    this._subscriptions.push(
      this._companyService.get().subscribe(e => {
        this.companies = e.filter(c => c.id > 1);
      })
    );
  }

  public getUserColor() {
    switch (this.roleLabel) {
      case 'Employee': return 'var(--progreso-accent)';
      case 'manager': return 'var(--progreso-accent-hover)';
      case 'Trainer': return 'var(--progreso-primary)';
      case 'LocalHr': return 'var(--progreso-secondary)';
      case 'CorporateHr': return 'var(--progreso-secondary)';
      default: return 'var(--progreso-accent)';
    }
  }

  public canShowFromSettings(menuItem: MenuItem): boolean {
    const filtered = this.settings.filter(
      (s) => s.menuItemId != null && s.menuItemId === menuItem.id
    );
    if (filtered && filtered.length) {
      return filtered[0].value;
    }
    return true;
  }

  public clickFavourite(menuItem: MenuItem): void {
    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToUrl(menuItem.getAngularUrl(), menuItem);
    }

    if (menuItem && (menuItem.id == 697 || menuItem.id == 698 || menuItem.id == 699 || menuItem.id == 700)) {
      let parameters = {};
      let url = 'chr/company';
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments';
          break;
        case 698:
        case 699: url = 'chr/companypositions';
          break;
        case 700: url = 'chr/companyfunctions';
          break;
      }

      if (this.companies.length == 1) {
        parameters['item'] = this.companies[0].id;
        parameters['employee'] = null;
        this.navigateToUrl(url, menuItem, parameters);
      } else {
        let modal = this.modalService.open(this.modalcontent, { backdrop: true, size: 'sm' });
        modal.result.then((a) => {
          parameters['item'] = a;
          parameters['employee'] = null;
          this.navigateToUrl(url, menuItem, parameters);
        }, () => { })
      }
    }
  }

  public startSortingFavorites() {
    this.sortFavoriteMode = true;
  }
  public stopSortingFavorites() {
    this.sortFavoriteMode = false;
  }
  public dropFavorite(event: CdkDragDrop<string[]> | any) {
    moveItemInArray(this.favourites, event.previousIndex, event.currentIndex);

    for (let i = 0; i < this.favourites.length; i++) {
      const element = this.favourites[i];
      element.sortOrder = i + 1;
    }

    this._subscriptions.push(this._navigationService.sortFavourites(this.favourites).subscribe());
  }

  public navigatetowhoiswho(): void {
    this._router.navigate(['/who-is-who'], {
      queryParams: {
        search: this.whoIsWhoSearchInput.nativeElement.value,
      },
    });
  }

  public navigatetotimeline(): void {
    if (localStorage.getItem('delegate_view') == "1") {
      this._router.navigate(['/delegate/my-team/timeline']);
    } else if (localStorage.getItem('manager_view') == "1") {
      this._router.navigate(['/manager/my-team/timeline'], {
        queryParams: {
          netfilter: localStorage.getItem('manager_view'),
        },
      });
    } else {
      this._router.navigate(['/timeline']);
    }
  }

  public getTimeLineUrl(): string {
    if (localStorage.getItem('delegate_view') == "1") {
      return '/delegate/my-team/timeline';
    } else if (localStorage.getItem('manager_view') == "1") {
      return '/manager/my-team/timeline';
    } else {
      return '/timeline';
    }
  }

  public print() {
    window.print();
  }

  public openNav() {
    document.getElementById('personalNav').style.width = '100%';
    document.getElementById('openPersonalNav').style.display = 'none';
    document.getElementById('closePersonalNav').style.display = 'block';
    document
      .getElementById('mainNavBtn')
      .parentElement.classList.add('selected');
    document.getElementById('extraNavigation').style.display = 'none';
    document.getElementById('moduleNavigation').style.display = 'block';
  }

  public closeNav() {
    document.getElementById('personalNav').style.width = '0%';
    document.getElementById('openPersonalNav').style.display = 'block';
    document.getElementById('closePersonalNav').style.display = 'none';
    document.getElementById('extraNavBtn').classList.remove('selected');
    document.getElementById('mainNavBtn').classList.remove('selected');
  }

  public showMainNav() {
    document.getElementById('moduleNavigation').style.display = 'block';
    document.getElementById('extraNavigation').style.display = 'none';
    document
      .getElementById('mainNavBtn')
      .parentElement.classList.add('selected');
    document
      .getElementById('extraNavBtn')
      .parentElement.classList.remove('selected');
  }

  public showExtraNav() {
    document.getElementById('moduleNavigation').style.display = 'none';
    document.getElementById('extraNavigation').style.display = 'block';
    document
      .getElementById('extraNavBtn')
      .parentElement.classList.add('selected');
    document
      .getElementById('mainNavBtn')
      .parentElement.classList.remove('selected');
  }

  public navigateToTaskDetail(task: Task): void {
    this.taskLogicService.navigateToTaskDetail(task);
    this.taskListOpen = false;
  }

  public navigateToArchives(): void {
    this._router.navigate(['/framework/blackboard/archive-employee'], {});
  }

  public navigateToStudent(): void {
    const employee = this.employeeSearchInput.nativeElement.value.trim();

    if (employee) {
      this._router.navigate(['/chr/company/employees/search'], {
        queryParams: {
          employee,
        },
      });
    } else {
      this._router.navigate(['/chr/company/employees/search']);
    }
  }

  public navigateToCompany(): void {
    if (this.searchInputCompany.nativeElement.value != '') {
      if (this.searchInputCompany.nativeElement.value.toLowerCase() == 'master') {
        this._router.navigate(['/chr/company'], { queryParams: { cy: -1, } });
      } else {
        this._router.navigate(['/framework/organization-search'], { queryParams: { search: this.searchInputCompany.nativeElement.value.toLowerCase() } });
      }
    } else {
      this._router.navigate(['/framework/organization-search']);
    }
  }

  public sendMailToServicedesk(): void {
    window.open(this.serviceDeskUrl, '_blank');
  }

  public navigateToActivelist(): void {
    window.open('/chr/activelist', '_blank');
  }

  ngOnDestroy(): void {
    for (const subscription of this._subscriptions) {
      subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  private findMenuItemRecursive(item: MenuItem, itemsToFind: number[]): MenuItem {
    if (this.isinArray(item.id, itemsToFind) && item.url != "") {
      return item;
    } else {
      for (let i = 0; i < item.subPages.length; i += 1) {
        let result = this.findMenuItemRecursive(item.subPages[i], itemsToFind);
        if (result != null && result.url != "")
          return result;
      }
    }
    return null;
  }

  private setupNavigationEventListener(): void {
    this._subscriptions.push(
      this._router.events
        .pipe(
          filter((event: Event) => event instanceof NavigationEnd),
          tap((event: Event) => {
            let url = (event as NavigationEnd).url;
            let param = getParameterByName('menuItem', url);
            const formattedUrl = this.formatUrl(url);
            const activeMenuItem = this.containsUrl(
              formattedUrl,
              this.home,
              (!param ? null : parseInt(param))
            );

            if (activeMenuItem) {
              this.activeMenuItem = activeMenuItem;

              for (const favourite of this.favourites) {
                if (activeMenuItem && favourite.menuItem.getAngularUrl() == activeMenuItem.getAngularUrl()) {
                  favourite.isActive = true;
                } else {
                  favourite.isActive = false;
                }
              }
            }
          })
        )
        .subscribe()
    );
  }

  private navigateToUrl(url: string, menuItem: MenuItem, extraQueryParams?) {
    this._router.navigate([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
  }

  private formatUrl(url: string): string {
    let formattedUrl = url.replace('/', '');
    if (formattedUrl.indexOf('?') > -1) {
      formattedUrl = formattedUrl.slice(0, formattedUrl.indexOf('?'));
    }

    const parts = formattedUrl.split('/');
    if (new RegExp(/^\d+$/).test(parts[parts.length - 1])) {
      parts.pop();
      parts.push(':id');
      formattedUrl = parts.join('/');
    }

    return formattedUrl;
  }

  private containsUrl(formattedUrl: string, menuItem: MenuItem, menuItemId?: number, menuItemInParent = false): MenuItem {
    if (!menuItem) {
      return null;
    }

    const itemFormattedUrl = menuItem.url.substring(1);

    if (menuItem && (formattedUrl === itemFormattedUrl || formattedUrl.replace("/:id", "") === itemFormattedUrl) && (!menuItemId || menuItemId == menuItem.id || menuItemInParent)) {
      menuItem.isActive = true;
      return menuItem;
    }

    if (menuItem.subPages) {
      for (let i = 0; i < menuItem.subPages.length; i++) {
        const subItem: MenuItem = menuItem.subPages[i];

        if (!subItem) {
          continue;
        }

        menuItemInParent = !!menuItemId && (menuItemInParent || menuItem.id == menuItemId);
        const activeMenuItem = this.containsUrl(formattedUrl, subItem, menuItemId, menuItemInParent);
        if (activeMenuItem != null) {
          menuItem.subPages[i].hasActiveTrail = true;
          menuItem.hasActiveTrail = true;
          return activeMenuItem;
        }
      }
    }
    return null;
  }

  private isinArray(id, itemsToFind): boolean {
    return itemsToFind.find(element => element == id) != null;
  }
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
